import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { ErrorPage, Login, Outdoor, GenericPage } from "../../pages/";
import { Layout } from "../../root";
import {
  clientsRoute,
  customerRoute,
  equipmentsRoute,
  optionsRoute,
  storeRoute,
  modelsRoute,
  userRoute,
  otsRoute,
  reportsRoute,
  schedulesRoute,
  supplierRoute,
} from "../routes";
import { Dashboard } from "../../libs/shared/dashboard/dashboard";
import { almacenRoutes } from "../routes/libs/almacen";
import { qrBatchRoutes } from "../routes/libs/qr-batch";

const GenericExteriorPage = React.lazy(
  () => import("../../pages/lib/generic-exterior"),
);
const SupplierPage = React.lazy(
  () => import("../../pages/lib/supplier-page/page"),
);
const OtsValidateProcess = React.lazy(
  () => import("../../pages/lib/page-wait-process"),
);
const OtsValidateCancel = React.lazy(
  () => import("../../pages/lib/page-wait-cancel"),
);
const OtsSupplierAccept = React.lazy(
  () => import("../../pages/lib/page-wait-supplier-accept"),
);
const OtsSupplierCancel = React.lazy(
  () => import("../../pages/lib/page-wait-supplier-cancel"),
);
const QrPublicWizard = React.lazy(
  () => import("../../components/qr-public/components/wizard/page"),
);

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/qr/:token",
    element: <QrPublicWizard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/exterior",
    element: <Outdoor />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "equipment/*",
        element: <GenericExteriorPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "supplier-ots",
        element: <SupplierPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "ots/process/*",
        element: <OtsValidateProcess />,
        errorElement: <ErrorPage />,
      },
      {
        path: "ots/cancel/*",
        element: <OtsValidateCancel />,
        errorElement: <ErrorPage />,
      },
      {
        path: "ots/valid-by-supplier/*",
        element: <OtsSupplierAccept />,
        errorElement: <ErrorPage />,
      },
      {
        path: "ots/cancel-by-supplier/*",
        element: <OtsSupplierCancel />,
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
        errorElement: <ErrorPage />,
      },
      {
        path: "clients",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: clientsRoute,
      },
      {
        path: "customers",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: customerRoute,
      },
      {
        path: "equipments",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: equipmentsRoute,
      },
      {
        path: "ots",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: otsRoute,
      },
      {
        path: "reports",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: reportsRoute,
      },
      {
        path: "options",
        // element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: optionsRoute,
      },
      {
        path: "store",
        errorElement: <ErrorPage />,
        children: storeRoute,
      },
      {
        path: "almacen",
        errorElement: <ErrorPage />,
        children: almacenRoutes,
      },
      {
        path: "qr-batch",
        errorElement: <ErrorPage />,
        children: qrBatchRoutes,
      },
      {
        path: "models",
        // element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: modelsRoute,
      },
      {
        path: "schedule",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: schedulesRoute,
      },
      {
        path: "suppliers",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: supplierRoute,
      },
      {
        path: "user",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: userRoute,
      },
      {
        path: "",
        element: <Navigate replace to="dashboard" />,
      },
    ],
  },
  {
    path: "",
    element: <Login />,
  },
]);
